import { toast } from 'react-toastify';
import './toast.css'

toast.configure({
  hideProgressBar: true,
  draggable: false,
})

export default toast
